module.exports = __webpack_public_path__ + "./images/57615eb3f0aa59b5a191ec3d1fb09042.webp";